(function () {
  'use strict';

  var ARROW_LEFT = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';
  var ARROW_RIGHT = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';

  var STYLES = [
    'media-gallery { position: relative !important; }',
    '.rmk-carousel-btn { position: absolute; top: 50%; transform: translateY(-50%);',
    ' z-index: 20; display: flex; align-items: center; justify-content: center;',
    ' width: 44px; height: 44px; border-radius: 50%; border: none; cursor: pointer;',
    ' background: rgba(255,255,255,0.85); backdrop-filter: blur(4px);',
    ' box-shadow: 0 2px 8px rgba(0,0,0,0.25); color: #1a1a1a;',
    ' transition: background 0.2s, transform 0.1s; padding: 0; }',
    '.rmk-carousel-btn:hover { background: rgba(255,255,255,0.98); }',
    '.rmk-carousel-btn:active { transform: translateY(-50%) scale(0.93); }',
    '.rmk-carousel-btn--prev { left: 12px; }',
    '.rmk-carousel-btn--next { right: 12px; }',
    '.rmk-carousel-btn[hidden] { display: none !important; }',

    /* === Collection carousel === */
    '.rmk-coll-wrap { position: relative; overflow: hidden; }',
    '.rmk-coll-wrap .resource-list--grid {',
    ' display: flex !important; flex-wrap: nowrap !important;',
    ' overflow-x: auto !important; overflow-y: visible !important;',
    ' scroll-behavior: smooth;',
    ' -ms-overflow-style: none; scrollbar-width: none; gap: 16px; }',
    '.rmk-coll-wrap .resource-list--grid::-webkit-scrollbar { display: none; }',
    /* Desktop: ~27% per card so 4th is ~30% cut off, hinting at scroll */
    '.rmk-coll-wrap .resource-list__item {',
    ' flex: 0 0 calc(27% - 12px); min-width: 200px; }',

    /* Collection arrow buttons – inside the wrap, overlapping card edges */
    '.rmk-coll-btn { position: absolute; top: 50%; transform: translateY(-50%);',
    ' z-index: 10; display: flex; align-items: center; justify-content: center;',
    ' width: 44px; height: 44px; border-radius: 50%; border: none; cursor: pointer;',
    ' background: rgba(255,255,255,0.85); backdrop-filter: blur(4px);',
    ' box-shadow: 0 2px 8px rgba(0,0,0,0.25); color: #1a1a1a;',
    ' transition: background 0.2s, transform 0.1s; padding: 0; }',
    '.rmk-coll-btn:hover { background: rgba(255,255,255,0.98); }',
    '.rmk-coll-btn:active { transform: translateY(-50%) scale(0.93); }',
    '.rmk-coll-btn--prev { left: 8px; }',
    '.rmk-coll-btn--next { right: 8px; }',
    '.rmk-coll-btn[hidden] { display: none !important; }',

    '@media (max-width: 749px) {',
    ' .rmk-coll-wrap .resource-list__item { flex: 0 0 75vw; min-width: 180px; }',
    ' .rmk-coll-btn { width: 36px !important; height: 36px !important; }',
    ' .rmk-coll-btn--prev { left: 6px !important; }',
    ' .rmk-coll-btn--next { right: 6px !important; } }'
  ].join('\n');

  function injectCSS() {
    if (document.getElementById('rmk-carousel-styles')) return;
    var s = document.createElement('style');
    s.id = 'rmk-carousel-styles';
    s.textContent = STYLES;
    document.head.appendChild(s);
  }

  /* ── Product image carousel ── */
  function initProductCarousel() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    if (gallery.querySelector('.rmk-carousel-btn')) return;
    var sc = gallery.querySelector('slideshow-component');
    if (!sc) return;
    var slides = gallery.querySelectorAll('slideshow-slide');
    if (slides.length <= 1) return;

    var prevBtn = document.createElement('button');
    prevBtn.className = 'rmk-carousel-btn rmk-carousel-btn--prev';
    prevBtn.setAttribute('aria-label', 'Vorheriges Bild');
    prevBtn.setAttribute('type', 'button');
    prevBtn.innerHTML = ARROW_LEFT;

    var nextBtn = document.createElement('button');
    nextBtn.className = 'rmk-carousel-btn rmk-carousel-btn--next';
    nextBtn.setAttribute('aria-label', 'Naechstes Bild');
    nextBtn.setAttribute('type', 'button');
    nextBtn.innerHTML = ARROW_RIGHT;

    gallery.appendChild(prevBtn);
    gallery.appendChild(nextBtn);

    function update() {
      try { prevBtn.hidden = !!sc.atStart; nextBtn.hidden = !!sc.atEnd; } catch(e) {}
    }

    prevBtn.addEventListener('click', function(e) { e.preventDefault(); sc.previous(); setTimeout(update, 200); });
    nextBtn.addEventListener('click', function(e) { e.preventDefault(); sc.next(); setTimeout(update, 200); });

    ['change', 'slideshow:changed', 'slide:changed'].forEach(function(evt) {
      sc.addEventListener(evt, update);
      gallery.addEventListener(evt, update);
    });

    var lastIdx = -1;
    setInterval(function() {
      try { var cur = sc.current; if (cur !== lastIdx) { lastIdx = cur; update(); } } catch(e) {}
    }, 250);

    update();
  }

  /* ── Collection list carousel ── */
  function initCollectionCarousel() {
    var sections = document.querySelectorAll('.section-resource-list');
    Array.prototype.forEach.call(sections, function(sec) {
      var grid = sec.querySelector('.resource-list--grid');
      if (!grid || sec.querySelector('.rmk-coll-btn')) return;
      var items = grid.querySelectorAll('.resource-list__item');
      if (items.length <= 1) return;

      /* Wrap the grid so we can position buttons over it */
      var wrap = document.createElement('div');
      wrap.className = 'rmk-coll-wrap';
      grid.parentNode.insertBefore(wrap, grid);
      wrap.appendChild(grid);

      var prevBtn = document.createElement('button');
      prevBtn.className = 'rmk-coll-btn rmk-coll-btn--prev';
      prevBtn.setAttribute('aria-label', 'Zurueck');
      prevBtn.setAttribute('type', 'button');
      prevBtn.innerHTML = ARROW_LEFT;

      var nextBtn = document.createElement('button');
      nextBtn.className = 'rmk-coll-btn rmk-coll-btn--next';
      nextBtn.setAttribute('aria-label', 'Vor');
      nextBtn.setAttribute('type', 'button');
      nextBtn.innerHTML = ARROW_RIGHT;

      wrap.appendChild(prevBtn);
      wrap.appendChild(nextBtn);

      function updateColl() {
        prevBtn.hidden = grid.scrollLeft <= 8;
        nextBtn.hidden = (grid.scrollLeft + grid.clientWidth) >= (grid.scrollWidth - 8);
      }

      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        grid.scrollBy({ left: -(grid.clientWidth * 0.85), behavior: 'smooth' });
        setTimeout(updateColl, 450);
      });
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        grid.scrollBy({ left: grid.clientWidth * 0.85, behavior: 'smooth' });
        setTimeout(updateColl, 450);
      });

      grid.addEventListener('scroll', updateColl, { passive: true });
      updateColl();
      /* Re-check once layout has fully settled */
      setTimeout(updateColl, 600);
    });
  }

  function init() {
    injectCSS();
    initProductCarousel();
    initCollectionCarousel();
  }

  /* Watch for dynamic content (Shopify sections loaded async) */
  var productDone = false;
  var collDone = false;
  var obs = new MutationObserver(function() {
    if (!productDone && document.querySelector('media-gallery slideshow-component')) {
      productDone = true; setTimeout(initProductCarousel, 400);
    }
    if (!collDone && document.querySelector('.section-resource-list .resource-list--grid')) {
      collDone = true; setTimeout(initCollectionCarousel, 400);
    }
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(init, 400); });
  } else {
    setTimeout(init, 400);
  }
})();
